module.exports = __webpack_public_path__ + "assets/img/noData.7e141750.png";